module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-wrap"
  }, [_c('div', {
    class: _vm.setChartClass()
  }, [(this.type === 'pie') ? _c('PieChart', {
    attrs: {
      "chartData": _vm.fillData(),
      "settings": _vm.setPieOptions(),
      "height": _vm.setHeight('pie'),
      "width": _vm.setWidth('pie'),
      "chartId": _vm.getChartId()
    }
  }) : _vm._e(), _vm._v(" "), (this.type === 'line') ? _c('LineChart', {
    attrs: {
      "chartData": _vm.fillData(),
      "height": _vm.setHeight('line'),
      "width": _vm.setWidth('line'),
      "settings": _vm.setLineOptions(),
      "chartId": _vm.getChartId()
    }
  }) : _vm._e(), _vm._v(" "), (this.type === 'bar') ? _c('BarChart', {
    attrs: {
      "chartData": _vm.fillData(),
      "height": _vm.setHeight('bar'),
      "width": _vm.setWidth('bar'),
      "settings": _vm.setBarOptions(),
      "chartId": _vm.getChartId()
    }
  }) : _vm._e(), _vm._v(" "), (this.type === 'horizontalBar') ? _c('HorizontalBarChart', {
    attrs: {
      "chartData": _vm.fillData(),
      "height": 250,
      "settings": _vm.setBarOptions(),
      "chartId": _vm.getChartId()
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "chart-legend",
    attrs: {
      "id": _vm.getLegendId()
    }
  })], 1), _vm._v(" "), _c('div', {
    class: _vm.setChartClass(true)
  }, [(this.type === 'pie') ? _c('PieChart', {
    attrs: {
      "chartData": _vm.fillData(),
      "settings": _vm.setPieOptions(true),
      "height": _vm.setHeight('pie'),
      "width": _vm.setWidth('pie'),
      "chartId": _vm.getChartId(true)
    }
  }) : _vm._e(), _vm._v(" "), (this.type === 'line') ? _c('LineChart', {
    attrs: {
      "chartData": _vm.fillData(),
      "height": _vm.setHeight('line'),
      "width": _vm.setWidth('line'),
      "settings": _vm.setLineOptions(true),
      "chartId": _vm.getChartId(true)
    }
  }) : _vm._e(), _vm._v(" "), (this.type === 'bar') ? _c('BarChart', {
    attrs: {
      "chartData": _vm.fillData(),
      "height": _vm.setHeight('bar'),
      "width": _vm.setWidth('bar'),
      "settings": _vm.setBarOptions(true),
      "chartId": _vm.getChartId(true)
    }
  }) : _vm._e(), _vm._v(" "), (this.type === 'horizontalBar') ? _c('HorizontalBarChart', {
    attrs: {
      "chartData": _vm.fillData(),
      "height": 250,
      "settings": _vm.setBarOptions,
      "chartId": _vm.getChartId(true)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "chart-legend",
    attrs: {
      "id": _vm.getLegendId(true)
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c4c5995c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chart.vue
// module id = 333
// module chunks = 0